/**
 * O modo da liquidação em uma letra: T (liquida o título), P (mantém aberto) ou A (amortiza as
 * parcelas da operação). `undefined` conta como total, igual ao `modeOf`.
 */
import { modeOf } from '../../pages/billing/constants/liquidationModes';

const BADGE_CLASS = 'inline-block min-w-[1.25rem] px-1.5 py-0.5 rounded text-[10px] font-semibold text-white';

export const totalPartialBadge = (totalPayment: boolean | null | undefined) => {
    const mode = modeOf(totalPayment);
    if (mode === 'TOTAL') return { text: 'T', color: 'bg-green-500', title: 'Pagamento total' };
    if (mode === 'PARTIAL') return { text: 'P', color: 'bg-pay-partial', title: 'Pagamento parcial' };
    return { text: 'A', color: 'bg-[#7c3aed]', title: 'Amortização de parcelas' };
};

const TotalPartialBadge: React.FC<{ totalPayment: boolean | null | undefined }> = ({ totalPayment }) => {
    const badge = totalPartialBadge(totalPayment);
    return <span className={`${BADGE_CLASS} ${badge.color}`} title={badge.title}>{badge.text}</span>;
};

export default TotalPartialBadge;
